import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "../helpers/AnimationRevealPage.js";
// import Hero from "../components/hero/TwoColumnWithInput.js";
import Features from "../components/features/ThreeColWithSideImage.js";
import MainFeature from "../components/features/TwoColWithButton.js";
import MainFeature2 from "../components/features/TwoColWithTwoHorizontalFeaturesAndButton.js";
import FeatureWithSteps from "../components/features/TwoColWithSteps.js";
import Pricing from "../components/pricing/ThreePlans.js";
import Testimonial from "../components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "../components/faqs/SingleCol.js";
import GetStarted from "../components/cta/GetStarted";
import Headers from "../components/headers/light.js";
import Footer from "../components/footers/Disclaimer.js";
import heroScreenshotImageSrc from "src/images/hero2.png";
import macHeroScreenshotImageSrc from "src/images/hero3.png";
import prototypeIllustrationImageSrc from "src/images/prototype-illustration.svg";
// import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
// import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";
// import { Power } from "react-feather";
import { LightBulbIcon, LockClosedIcon} from "@heroicons/react/24/outline";
import { Helmet } from "react-helmet";

const ProductPage = () => {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-500`;
  const Paragraph = tw.p`mb-4 leading-relaxed text-xl text-secondary-900`;

  return (
    <>
    <Helmet>
        <title>AI Vision – Blake Technologies</title>
        <meta property="og:title" content="Blake Technologies – AI Vision APIs" />
        <meta property="og:description" content="Detect, recognize, and extract data from images with our AI-powered APIs." />
        <meta property="og:image" content="https://res.cloudinary.com/dvhwuuffw/image/upload/v1758057089/ChatGPT_Image_Sep_16_2025_09_10_32_PM_i4op4r.png" />
        <meta property="og:url" content="https://website-phi-lilac.vercel.app/product/ai_vision" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Blake Technologies" />
      </Helmet>
    <AnimationRevealPage>
      {/* <Hero roundedHeaderButton={true} /> */}
      <Headers></Headers>
      <Features
        subheading={<Subheading><span style={{color:"#6373FF"}}>Features</span></Subheading>}
        heading={
          <>
           <span style={{color:"#6373FF"}}>We Offer Amazing <HighlightedText>AI-Powered APIs</HighlightedText> <br/>for Your Business Needs</span> 
          </>
        }
      />
      <MainFeature
        subheading={<Subheading><span style={{color:"#6373FF"}}>Quality Work</span></Subheading>}
        imageSrc={heroScreenshotImageSrc}
        imageBorder={true}
        imageDecoratorBlob={true}
      />
      <FeatureWithSteps
        subheading={<Subheading> <span style={{color:"#6373FF"}}>STEPS</span></Subheading>}
        heading={
          <>
           <span style={{color:"#6373FF"}}> Easy to <HighlightedText>Get Started.</HighlightedText></span>
          </>
        }
        textOnLeft={false}
        imageSrc={macHeroScreenshotImageSrc}
        imageDecoratorBlob={true}
        decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-10 -translate-x-1/2 left-1/2`}
      />
      <MainFeature2
        subheading={<Subheading><span style={{color:"#6373FF"}}>VALUES</span></Subheading>}
        heading={
          <>
           <span style={{color:"#6373FF"}}> We Always Abide by Our <HighlightedText>Principles.</HighlightedText></span>
          </>
        }
        imageSrc={prototypeIllustrationImageSrc}
        showDecoratorBlob={false}
        features={[
          {
            Icon: LightBulbIcon,
            title: "Innovative",
            description: "Pushing boundaries to create smarter AI solutions..",
            iconContainerCss: tw`bg-yellow-300 text-green-800`
          },
          {
            Icon: LockClosedIcon,
            title: "Integrity",
            description: "Ensuring trust, security, and ethical AI practices.",
            iconContainerCss: tw`bg-red-300 text-red-800`
          }
        ]}
      />
      <Pricing
        subheading={<Subheading><span style={{color:"#6373FF"}}>Pricing</span></Subheading>}
        heading={
          <>
          <span style={{color:"#6373FF"}}>Reasonable & Flexible <HighlightedText>Plans.</HighlightedText></span>
          </>
        }
        plans={[
          {
            name: "Free/Pay As you go",
            price: "$0.00",
            duration: "",
            mainFeature: "Recommended For Individuals",
            features: ["100 Free Credits, $0.01/credit", "10 Request/min" ,"Facial Recognition APIs", "Text Extraction with Named Entity Recognition (NER)", "Object Detection", "Basic Assistance"]
          },
          {
            name: "Pro",
            price: "$19.99",
            duration: "Monthly",
            mainFeature: "Recommended for Teams and Small Businesses",
            features: ["10,000 Credits/month", "50 requests/min", "+Free Plan","No Ads", "Priority Assistance"],
            featured: true
          },
          
          {
            name: "Business",
            price: "$39.99",
            duration: "Monthly",
            mainFeature: "Recommended for Businesses and Large Teams",
            features: ["25,000 credits/month", "100 requests/min","Feature Request","Advanced Entity Extraction API","+Pro Plan","$0.0075/credit", "Dedicated Support"]
          }
        ]}
      />
      <Pricing
      heading=""
      subheading=""
      description=""
      plans={[
        {
          name: "Enterprise",
          price: "",
          duration: "",
          mainFeature: "Recommended For Large Companies",
          features: ["Contact Sales",]
        }
      ]}
      />
      <Paragraph><strong>Pricing Notice:</strong>  Prices listed are exclusive of applicable taxes and fees. For mobile purchases, Google Play or App Store may include additional tax or region-specific charges.</Paragraph>
      <Testimonial
        subheading={<Subheading><span style={{color:"#6373FF"}}>Testimonials</span></Subheading>}
        heading={
          <>
           <span style={{color:"#6373FF"}}> Our Clients <HighlightedText>Love Us.</HighlightedText></span>
          </>
        }
        testimonials={[
          {
            stars: 5,
            profileImageSrc:
              "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80",
            heading: "Incredible Accuracy & Speed",
            quote:
              "BlakeVision's AI APIs have revolutionized the way we process data. The text extraction and recognition capabilities are second to none. It has saved us countless hours and improved our workflow efficiency tremendously. Highly recommended!",
            customerName: "Daniel Carter",
            customerTitle: ""
          },
          {
            stars: 5,
            profileImageSrc:
              "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80",
            heading: "Seamless Integration & Outstanding Support",
            quote:
              "Integrating BlakeVision's AI services into our system was smooth and hassle-free. The team provided excellent support, and the API documentation made it easy to implement. Our clients are thrilled with the enhanced capabilities we now offer.",
            customerName: "Sophia Martinez",
            customerTitle: ""
          }
          
          
          // {
          //   stars: 5,
          //   profileImageSrc:
          //     "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80",
          //   heading: "Incredible Accuracy & Speed",
          //   quote:
          //     "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",
          //   customerName: "Charlotte Hale",
          //   customerTitle: ""
          // },
          // {
          //   stars: 5,
          //   profileImageSrc:
          //     "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
          //   heading: "Love the Developer Experience and Design Principles !",
          //   quote:
          //     "Sinor Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
          //   customerName: "Adam Cuppy",
          //   customerTitle: ""
          // }
        ]}
      />
      <FAQ
        subheading={<Subheading><span style={{color:"#6373FF"}}>FAQS</span></Subheading>}
        heading={
          <>
          <span style={{color:"#6373FF"}}> You have <HighlightedText>Questions ?</HighlightedText></span>
          </>
        }
        faqs={[
          {
            question: "How does BlakeVision charge for API usage?",
            answer:
              "We offer a flexible pricing model with a free/pay-as-you-go plan and subscription tiers. Each request costs a certain number of credit points, and you can adjust your plan based on your usage needs."
          },
          {
            question: "Can I test the APIs before committing to a paid plan?",
            answer:
              "Yes! Our free plan allows you to test the core functionalities with a limited number of requests. This way, you can evaluate the AI's capabilities before upgrading to a paid plan."
          },
          {
            question: "What industries does BlakeVision’s AI support?",
            answer:
              "BlakeVision is designed to be versatile, with AI models trained for healthcare, legal, business, and general applications. More industries will be added as we continue improving our services."
          },
          {
            question: "How secure is the data processed by the APIs?",
            answer:
              "Security is a top priority. We use end-to-end encryption, and no data is stored after processing. Our systems comply with industry standards for data privacy and protection."
          },
          {
            question: "How easy is it to integrate BlakeVision’s APIs into my application?",
            answer:
              "Our APIs are designed to be developer-friendly, with detailed documentation and SDKs available for multiple programming languages, making integration seamless and efficient."
          },
          {
            question: "Do you offer customer support if I run into issues?",
            answer:
              "Yes! We provide customer support via email and live chat for all users, with priority support available for premium plans. Our team is here to help you every step of the way."
          },
          {
            question: "Can I upgrade or downgrade my subscription at any time?",
            answer:
              "Absolutely! You can switch between plans at any time based on your business needs. Upgrades take effect immediately, while downgrades apply from the next billing cycle."
          }
          // {
          //   question: "Are all the templates easily customizable ?",
          //   answer:
          //     "Yes, they all are. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          // },
          // {
          //   question: "How long do you usually support an standalone template for ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          // },
          // {
          //   question: "What kind of payment methods do you accept ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          // },
          // {
          //   question: "Is there a subscribption service to get the latest templates ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          // },
          // {
          //   question: "Are the templates compatible with the React ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          // },
          // {
          //   question: "Do you really support Internet Explorer 11 ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          // }
        ]}
      />
      <GetStarted/>
      <Footer />
    </AnimationRevealPage>
    </>
  );
}

export default ProductPage;
